import React from 'react';
import {FormControl, InputLabel} from '@mui/material';
import {CommonProps} from "./FormControlFactory";
import {BootstrapInput} from "../../shared/form_controls/BootstrapInput";

export interface TextareaEditorProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, key: string) => void;
    value: string;
}

const TextEditor: React.FC<TextareaEditorProps> = ({elementKey, label, value, onChange}) => {
    return (
        <FormControl fullWidth sx={{mb: 2}}>
            <InputLabel sx={{
                color: '#C3F3FD',
                left: "-13px",
                top: "5px"
            }} shrink htmlFor={`${elementKey}-input`}>
                {label}
            </InputLabel>
            <BootstrapInput
                id={`${elementKey}-input`}
                placeholder={label}
                multiline={true}
                rows={2}
                variant="outlined"
                fullWidth
                value={value}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event, elementKey)}
            />
        </FormControl>
    );
};


export default TextEditor;
